// extracted by mini-css-extract-plugin
export default {"container":"PopupAlert_container__5swYH","popup":"PopupAlert_popup__hwHRU","closeIconImg":"PopupAlert_closeIconImg__D-RQi","closeIcon":"PopupAlert_closeIcon__UE+RL"};